import { Controller } from "@hotwired/stimulus"

// 10분 단위 출퇴근 시간 선택 모달 컨트롤러
export default class extends Controller {
  static targets = ["modal", "timeList", "input", "selectedTime"]
  static values = {
    startHour: { type: Number, default: 6 },
    endHour: { type: Number, default: 23 }
  }

  connect() {
    this.updateDisplay()
    this.renderTimeList()
  }

  updateDisplay() {
    const currentValue = this.inputTarget.value
    // datetime-local 값에서 시간만 추출
    const currentTime = currentValue ? currentValue.split('T')[1]?.substring(0, 5) : ''

    if (currentTime && this.hasSelectedTimeTarget) {
      this.selectedTimeTarget.textContent = currentTime
      this.selectedTimeTarget.classList.remove('text-gray-400')
      this.selectedTimeTarget.classList.add('text-gray-900')
    }
  }

  openModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
    this.renderTimeList()
  }

  closeModal() {
    this.modalTarget.close()
  }

  renderTimeList() {
    const currentValue = this.inputTarget.value
    // datetime-local 값에서 시간만 추출
    const currentTime = currentValue ? currentValue.split('T')[1]?.substring(0, 5) : ''
    const times = []

    for (let hour = this.startHourValue; hour <= this.endHourValue; hour++) {
      for (let min = 0; min < 60; min += 10) {
        const time = `${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`
        times.push(time)
      }
    }

    this.timeListTarget.innerHTML = times.map(time => `
      <button type="button"
              class="px-3 py-2 text-sm rounded-lg transition-colors ${time === currentTime ? 'bg-blue-500 text-white font-medium' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'}"
              data-action="click->work-time-picker#selectTime"
              data-time="${time}">
        ${time}
      </button>
    `).join('')
  }

  selectTime(event) {
    const time = event.currentTarget.dataset.time

    // datetime-local 형식으로 업데이트 (현재 날짜 유지)
    const currentValue = this.inputTarget.value
    let date = new Date().toISOString().split('T')[0]

    if (currentValue) {
      const datePart = currentValue.split('T')[0]
      if (datePart) date = datePart
    }

    this.inputTarget.value = `${date}T${time}`

    // 선택된 시간 표시
    this.selectedTimeTarget.textContent = time

    // 스타일 클래스 업데이트 (회색 -> 검정색)
    this.selectedTimeTarget.classList.remove('text-gray-400')
    this.selectedTimeTarget.classList.add('text-gray-900')

    // 모달 닫기
    this.closeModal()
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }

  // 시간 초기화
  clearTime(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.selectedTimeTarget.textContent = "시간을 선택하세요"
    this.closeModal()
  }
}
